<template>
  <span
    :class="tagClass"
    @click="deleteCriterion"
  >
    <span :id="tooltip" :title="criterionTitle">
      <div
        class="dynamic-tag-names"
        v-text="criterionValue"
      />
      <i
        v-if="showDelete"
        class="multiselect__tag-icon"
        v-text="'x'"
      />
    </span>
  </span>
</template>

<script>
export default {
  name: 'Criterion',
  props: {
    criterion: {
      default: function () {
        return {}
      },
      type: Object
    },
    showValue: {
      default: false,
      type: Boolean
    },
    showDelete: {
      default: false,
      type: Boolean
    },
    block: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      applied: false
    }
  },
  created () {
    let self = this
    this.$eventBus.$on('applyFilters', (fromSorting) => {
      if (fromSorting != null && fromSorting) { return }
      self.applied = true
    })
  },
  computed: {
    criterionTitle () {
      if (this.criterion != null) {
        let value = this.criterion.Value !== null ? this.criterion.Value : ''
        return `${value} : ${this.criterion.TypeName}`
      }
    },
    criterionValue () {
      if (this.criterion != null) {
        let value = this.criterion.Value !== null ? this.criterion.Value : ''
        if (value.toString().length > 4) { return `${value.slice(0, 4)}...` }
        return `${value}`
      }
    },
    tagClass () {
      return {
        'block': this.block,
        'multiselect__tag__applied': this.applied,
        'multiselect__tag': !this.applied
      }
    },
    tooltip () {
      return this.applied ? 'tooltip_active' : 'tooltip'
    }
  },
  methods: {
    deleteCriterion () {
      this.$emit('deleteCriterion', this.criterion)
    }
  }
}
</script>

<style scoped lang="scss">
  /*@import "~ui.kit.styling";*/
  @import '../../../kit-components/uikit';

  .multiselect__tag {
    border-radius: 2px;
    height: 25px;
    color: #fff;
    padding: 0 10px;
    line-height: 25px;
    display: inline-block;
    margin: 5px 5px 10px 5px;
    background-color: $pendingBlue;

    &:hover {
      cursor: pointer;
      filter: brightness(1.1);
    }
    span {
      display: inline-block;
    }
  }

  .multiselect__tag__applied {
    border-radius: 2px;
    height: 25px;
    color: $pendingBlue;
    padding: 0 10px;
    line-height: 25px;
    display: inline-block;
    margin: 5px 5px 10px 5px;
    background-color: white;
    border: $pendingBlue solid 1px;
    &:hover {
      cursor: pointer;
      filter: brightness(1.1);
    }
    span {
      display: inline-block;
    }
  }

  .dynamic-tag-names {
    display: inline-block;
    font-size: 0.85em
  }

  .close-filter {
    width: 11px;
    margin-left: 5px;
  }

  .block {
    display: block!important;
  }

  #tooltip[title]:hover:after {
    content: attr(title);
    position: relative;
    top: -100%;
    color: white;
    padding-left: 10px;
  }

  #tooltip_active[title]:hover:after {
    content: attr(title);
    position: relative;
    top: -100%;
    color: #00bbd5;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/grid/Criteria/Criterion.vue